import { useLayoutEffect, useCallback } from "react";
const { useSearchParams } = require("react-router-dom");

const setDarkMode = (isDarkMode) => {
  if (isDarkMode) {
    document.querySelector("html").setAttribute("data-theme-mode", "dark");
    document.querySelector("html").setAttribute("data-header-styles", "dark");
    document.querySelector("html").setAttribute("data-menu-styles", "dark");
    localStorage.setItem("darkMode", "true");
  } else {
    document.querySelector("html").setAttribute("data-theme-mode", "");
    document.querySelector("html").setAttribute("data-header-styles", "");
    document.querySelector("html").setAttribute("data-menu-styles", "");
    localStorage.removeItem("darkMode");
  }
};

const useTheme = (queryParam = "darkMode") => {
  const [searchParams] = useSearchParams();
  const theme = searchParams.get(queryParam);

  const isDarkMode = theme === "true" || theme === "1" || theme === true;

  useLayoutEffect(() => {
    setDarkMode(isDarkMode);
    console.log("Dark Mode", isDarkMode);
  }, [isDarkMode]);

  return {
    isDarkMode,
  };
};

export default useTheme;
